import * as React from 'react';

import { arrayRemove, lastItem } from '@freelancelabs/utils';

interface TooltipExclusiveContextValue {
    last?: string;
    add: (id: string) => void;
    remove: (id: string) => void;
}

export const TooltipExclusiveContext = React.createContext<TooltipExclusiveContextValue>(
    {} as TooltipExclusiveContextValue
);

const TooltipExclusive = ({ children }: { children: React.ReactNode }) => {
    const [tooltips, setTooltips] = React.useState<string[]>([]);

    const remove = (id: string) => {
        setTooltips((prev) => arrayRemove(prev, id));
    };

    const add = (id: string) => {
        setTooltips((prev) => [...prev, id]);
    };

    return (
        <TooltipExclusiveContext.Provider value={{ last: lastItem(tooltips), add, remove }}>
            {children}
        </TooltipExclusiveContext.Provider>
    );
};

export default TooltipExclusive;
